(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scripts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('easen-cart-consent')) {
    customElements.define('easen-cart-consent', class extends HTMLElement {
      connectedCallback() {
        this.consentController?.abort();
        this.consentController = new AbortController();
        const signal = this.consentController.signal;
        this.addEventListener('change', () => {
          const error = this.querySelector('.easen-consent__error');
          if (error) error.hidden = true;
        }, { signal });
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-consent-checkout]')) this.checkout();
        }, { signal });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted && this.saving) this.releaseControls();
        }, { signal });
      }
      releaseControls() {
        this.saving = false;
        this.querySelectorAll('input').forEach((input) => { input.disabled = false; });
        const button = this.querySelector('[data-consent-checkout]');
        if (button) button.disabled = false;
        this.removeAttribute('aria-busy');
      }
      disconnectedCallback() {
        this.consentController?.abort();
      }
      async checkout() {
        if (this.saving) return;
        const ko = this.dataset.locale === 'ko';
        const terms = this.querySelector('[data-terms]');
        const emailMarketing = this.querySelector('[data-email-marketing]');
        const optedIn = emailMarketing.checked;
        const error = this.querySelector('.easen-consent__error');
        const button = this.querySelector('[data-consent-checkout]');
        const fail = (message, input) => {
          error.style.removeProperty('color');
          error.textContent = message;
          error.hidden = false;
          if (input) { input.closest('details')?.setAttribute('open', ''); input.focus(); }
        };
        if (!terms.checked) {
          fail(ko ? '구매 이용약관에 동의해 주세요.' : 'Please agree to the Terms & Conditions.', terms);
          return;
        }
        if (this.dataset.preview === 'true') {
          error.style.color = 'inherit';
          error.textContent = ko ? '미리보기: 동의 확인 완료. 실제 저장이나 결제는 진행되지 않습니다.' : 'Preview: consent checks passed. No data is saved and no checkout is started.';
          error.hidden = false;
          return;
        }
        this.saving = true;
        button.disabled = true;
        this.querySelectorAll('input').forEach((input) => { input.disabled = true; });
        error.hidden = true;
        this.setAttribute('aria-busy', 'true');
        const now = new Date().toISOString();
        const attributes = {
          'Easen Terms consent': 'Agreed',
          'Easen Terms consent at': now,
          'Easen Terms URL': this.querySelector('.easen-consent__terms-button, .easen-consent__choice a')?.href || new URL('/policies/terms-of-service', window.location.origin).href,
          'Easen Email marketing consent': optedIn ? 'Agreed' : 'Not given for this order',
          'Easen Email marketing consent at': optedIn ? now : '',
          'Easen Email marketing recorded at': now,
          'Easen Email marketing consent text': emailMarketing.closest('label').textContent.replace(/\s+/g, ' ').trim(),
          'Easen Email marketing consent version': '2026-09-28-email-v1',
          'Easen Kakao data-use consent': '',
          'Easen Kakao advertising consent': '',
          'Easen Kakao mobile': '',
          'Easen Kakao consent at': '',
          'Easen consent version': '2026-09-28-v5-cart-email',
          'Easen consent language': this.dataset.locale,
          'Easen consent source': 'Storefront cart'
        };
        try {
          const response = await fetch(this.dataset.cartUrl + '/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('Unable to save consent');
          const cart = await response.json();
          if (!cart.item_count || Object.entries(attributes).some(([key, value]) => String(cart.attributes?.[key] ?? '') !== value)) throw new Error('Consent not saved');
          const root = this.dataset.root.replace(/\/?$/, '/');
          window.location.assign(root + 'checkout');
        } catch {
          fail(ko ? '동의 내용을 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.' : 'We could not save your consent. Please try again.');
          this.releaseControls();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
